import React, { useState, useEffect } from 'react';
import { CardImg, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';

function Slideshow({ slides, slideIndex, setSlideIndex }) {
    const plusSlides = (n) => {
        const newIndex = slideIndex + n;
        setSlideIndex(newIndex > slides.length ? 1 : (newIndex < 1 ? slides.length : newIndex));
    };

    const currentSlide = (n) => setSlideIndex(n);

    return (
        <div className="slideshow-container">
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`mySlides fade ${slideIndex === (index + 1) ? 'show' : ''}`}
                >
                    <div className="numbertext">{index + 1} / {slides.length}</div>
                    <CardImg src={slide.image} alt={slide.name} />
                    <div className="caption">{slide.name} - {slide.description}</div>
                </div>
            ))}
            <a className="prev" onClick={() => plusSlides(-1)}>&#10094;</a>
            <a className="next" onClick={() => plusSlides(1)}>&#10095;</a>
            <div style={{ textAlign: 'center' }}>
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${slideIndex === (index + 1) ? 'active' : ''}`}
                        onClick={() => currentSlide(index + 1)}
                    ></span>
                ))}
            </div>
        </div>
    );
}

function RenderNav({ item23, item24, item25, isLoading, errMess }) {
    const [slideIndex23, setSlideIndex23] = useState(1);
    const [slideIndex24, setSlideIndex24] = useState(1);
    const [slideIndex25, setSlideIndex25] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex23(prevIndex => (prevIndex % item23.length) + 1);
            setSlideIndex24(prevIndex => (prevIndex % item24.length) + 1);
            setSlideIndex25(prevIndex => (prevIndex % item25.length) + 1);
        }, 6000);

        return () => clearInterval(interval);
    }, [item23.length, item24.length, item25.length]);

    if (isLoading) {
        return <Loading />;
    } else if (errMess) {
        return <h4>{errMess}</h4>;
    } else {
        return (
            <div className="timeline">
                <div className="timelineContainer timelineRight">
                    <div className="timelineContent">
                        <h2>2025</h2>
                        <Slideshow slides={item25} slideIndex={slideIndex25} setSlideIndex={setSlideIndex25} />
                    </div>
                </div>

                <div className="timelineContainer timelineLeft">
                    <div className="timelineContent">
                        <h2>2024</h2>
                        <Slideshow slides={item24} slideIndex={slideIndex24} setSlideIndex={setSlideIndex24} />
                    </div>
                </div>

                <div className="timelineContainer timelineRight">
                    <div className="timelineContent">
                        <h2>2023</h2>
                        <Slideshow slides={item23} slideIndex={slideIndex23} setSlideIndex={setSlideIndex23} />
                    </div>
                </div>
            </div>
        );
    }
}

function UploadForm({ postAdventure, toggle }) {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        createdAt: '',
        yearSelection: 'a2024',
        image: null,  // Add image field to state
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevData => ({ ...prevData, [name]: value }));
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFormData(prevData => ({ ...prevData, image: file }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const { name, description, createdAt, yearSelection, image } = formData;
        postAdventure(name, description, createdAt, yearSelection, image);
        setFormData({
            name: '',
            description: '',
            createdAt: '',
            yearSelection: 'a2025',
            image: null,
        });
        toggle(); // Close modal after submission
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control"
                    required
                />
            </div>
            <div className="form-group">
                <label htmlFor="description">Description:</label>
                <input
                    type="text"
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="form-control"
                    required
                />
            </div>
            <div className="form-group">
                <label htmlFor="createdAt">Date and Time:</label>
                <input
                    type="datetime-local"
                    id="createdAt"
                    name="createdAt"
                    value={formData.createdAt}
                    onChange={handleChange}
                    className="form-control"
                    required
                />
            </div>
            <div className="form-group">
                <label htmlFor="yearSelection">Select Year:</label>
                <select
                    id="yearSelection"
                    name="yearSelection"
                    value={formData.yearSelection}
                    onChange={handleChange}
                    className="form-control"
                    required
                >
                    <option value="a2025">2025</option>
                    <option value="a2024">2024</option>
                    <option value="a2023">2023</option>
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="image">Upload Image:</label>
                <input
                    type="file"
                    id="image"
                    name="image"
                    onChange={handleFileChange}
                    className="form-control"
                    accept="image/*"
                    required
                />
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    );
}

function Adventure({ a2023, a2024, a2025, adventuresLoading, adventuresErrMess, postAdventure }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div className="container">
            <div className="row">
                <Breadcrumb>
                    <BreadcrumbItem><Link to='/home'>Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Adventure</BreadcrumbItem>
                </Breadcrumb>
                <div className="col-12">
                    <h3>Adventure</h3>
                    <hr />
                </div>
            </div>
            <div className='row'>
                <div className="col-12 offset-md-10">
                    <Button
                        outline
                        onClick={toggleModal}
                    >
                        <span className="fa fa-plus fa-lg"></span> Upload Image
                    </Button>
                    <Modal isOpen={isModalOpen} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>Upload New Image</ModalHeader>
                        <ModalBody>
                            <UploadForm postAdventure={postAdventure} toggle={toggleModal} />
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12 col-md m-1">
                    <RenderNav
                        item23={a2023}
                        item24={a2024}
                        item25={a2025}
                        isLoading={adventuresLoading}
                        errMess={adventuresErrMess}
                    />
                </div>
            </div>
        </div>
    );
}

export default Adventure;



// WEBPACK FOOTER //
// ./src/components/AdventureComponent.js